export const POLLING_DURATION = 5000;
export const POLLING_INTERVAL = 1500;
export const MAX_REQUEST_ATTEMPTS = 5;

// eslint-disable-next-line no-promise-executor-return
export const sleep = (ms = POLLING_INTERVAL) => new Promise((resolve) => setTimeout(resolve, ms));
